module.exports = __webpack_public_path__ + "static/media/TaskStatusPendingApproval.0ba2c9af.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/TaskStatusPendingApproval.mp3
// module id = 2828
// module chunks = 0